import { render, staticRenderFns } from "./AdsManager.vue?vue&type=template&id=40b28b2f&scoped=true&"
import script from "./AdsManager.vue?vue&type=script&lang=ts&"
export * from "./AdsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b28b2f",
  null
  
)

export default component.exports